<template>
  <!-- 用户信息 -->
  <div>
    <div class="global_top_nav_two">
      <div class="wrap">
        <div class="global_top_nav_two_left">
          深圳华侨城国际旅行社有限公司--
          <a href="javascript:;"
             style="cursor: default;">行程查询官网</a>
        </div>
        <div class="sale-info"
             v-if="$sessionStorageUtil.get('web_type') == 2">
          <span class="global_top_nav_two_center1">{{agent.agent_name_for_short}}</span>
          <span class="global_top_nav_two_center2">
            <span>营业部电话：{{agent.tel1}}</span>
            <span>{{agent.contact_person}}：{{agent.cellphone1}}</span>
            <br>
            <span>地址：{{agent.address}}</span>
          </span>
        </div>
        <div class="global_top_nav_two_right">
          <!-- 未登录 -->
          <div @mouseenter="loginEnter"
               @mouseleave="loginLeave"
               class="global_top_nav_two_right_inner"
               style="display: block;"
               v-if="!this.$isLogin(-1)">
            <dl class="login_box">
              <span class="login_enter"
                    href="javascript:void(0);">
                <img alt
                     src="@/assets/images/html/unlogin_face.png">
                <a @click="$pushByName($sessionStorageUtil.get('web_type')==2 ? 'login' : 'agentLogin')">登录</a>
                <a @click="$pushByName('regist')"
                   v-if="$sessionStorageUtil.get('web_type')==2">|注册</a>
              </span>
              <div v-show="login_flag">
                <dd class="login"
                    v-if="$sessionStorageUtil.get('web_type')==2">
                  <a @click="$pushByName('login')"
                     class="login"
                     href="javascript:void(0);">登入</a>
                </dd>
                <dd v-if="$sessionStorageUtil.get('web_type')==2">
                  <a @click="$pushByName('smsLogin')"
                     href="javascript:void(0);">游客登入</a>
                </dd>
                <dd>
                  <a @click="$pushByName('agentLogin')"
                     href="javascript:void(0);">员工入口</a>
                </dd>
              </div>
            </dl>
          </div>
          <!-- 登陆后 -->
          <div @mouseenter="loginEnter"
               @mouseleave="loginLeave"
               class="global_top_nav_two_right_inner"
               style="display: block;"
               v-else>
            <dl class="login_box">
              <a @click="center()"
                 class="login_enter overflow-ellipsis-line1"
                 href="javascript:void(0);">
                <img :src="portrait? portrait : default_face"
                     alt>
                {{respectfully()}}
              </a>
              <div v-show="login_flag">
                <dd>
                  <a @click="center()"
                     href="javascript:void(0);">个人中心</a>
                </dd>
                <dd>
                  <a @click="exit()"
                     href="javascript:void(0);">退出帐号</a>
                </dd>
                <dd>
                  <a @click="cutUser()"
                     href="javascript:void(0);">切换帐号</a>
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 用户信息结束 -->
</template>
<script>
import default_face from '@/assets/images/html/unlogin_face.png'
import { exitLogin } from '@/api/base'
export default {
  name: 'HeaderLogin',
  componentName: 'HeaderLogin',
  data () {
    return {
      isLogin: false,
      login_flag: false,
      is_popup: false,
      default_face: default_face,
      portrait: '',
      url: 'agent_info/by_domain_name',
      user_portrait_url: 'user_manager/portrait',
      face_url: default_face,
      agent: {}
    }
  },
  created () {
    this.$myGet(this.url)
      .then(res => {
        const rcode = res.response.data.rcode
        if (rcode == 0) {
          this.agent = res.response.data.agent_info
        } else {
          // this.$msg(res.response.data.messages[0].msg);
        }
      })
      .catch(err => {
        this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
      })
    if (this.$isLogin(-1)) {
      this.$myGet(this.user_portrait_url)
        .then(res => {
          this.portrait = res.response.data.portrait
        })
        .catch(err => {
          this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
        })
    }
  },
  methods: {
    respectfully () {
      let type = this.$loginType()
      let prefix = ''
      switch (type) {
        case 0:
          prefix = '尊敬的销售'
          break
        case 1:
          prefix = '尊敬的会员'
          break
        case 2:
          prefix = '尊敬的游客'
          break
        default:
          prefix = '尊敬的会员'
          break
      }
      return prefix + '' + this.$dataUtils.getLoginName()
    },
    center () {
      let type = this.$loginType()
      let push_name = 'login'
      switch (type) {
        case 0:
          push_name = 'personalData'
          break
        case 1:
          push_name = 'memberInfo'
          break
        case 2:
          push_name = 'memberInfo'
          break
        default:
          push_name = 'login'
          break
      }
      this.$pushByName(push_name)
    },
    loginEnter: function () {
      return (this.login_flag = true)
    },
    loginLeave: function () {
      return (this.login_flag = false)
    },
    exit () {
      let type = this.$loginType()
      this.$messageBox
        .confirm('退出登录后，您将不再收到任何消息提醒，是否确定退出？')
        .then(() => {
          exitLogin()
            .then(res => {
              this.exitPush(type)
            })
            .catch(err => {
              this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
            })
        })
        .catch(() => { })
    },
    exitPush (type) {
      let push_name = ''
      switch (type) {
        case 0:
          push_name = 'agentLogin'
          break
        case 1:
          push_name = 'login'
          break
        case 2:
          push_name = 'smsLogin'
          break
        default:
          push_name = 'agentLogin'
      }
      this.$router.push({ name: push_name })
    },
    cutUser () {
      let type = this.$loginType()
      this.exitPush(type)
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/components/headerLogin.vue